export const formatStatus = (status: string | null) => {
  if (!status) return ''
  return status
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

export const formatDeliveryDate = (date: string | null | undefined) => {
  if (!date) return null
  try {
    return new Date(date).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return date
  }
}

/**
 * Returns progress 0-100 from startDate to endDate, with today as current position.
 * Returns null if endDate is missing (cannot compute progress).
 * Fallback: if startDate is missing, uses createdAt.
 */
export const getDeliveryProgressFromRange = (
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  createdAt?: string
): number | null => {
  if (!endDate) return null
  const start = startDate
    ? new Date(startDate).getTime()
    : createdAt
    ? new Date(createdAt).getTime()
    : null
  if (!start) return null

  const end = new Date(endDate).getTime()
  const today = new Date().setHours(0, 0, 0, 0)
  const startDay = new Date(start).setHours(0, 0, 0, 0)
  const endDay = new Date(end).setHours(0, 0, 0, 0)

  if (today >= endDay) return 100
  if (today <= startDay) return 0

  const total = endDay - startDay
  const elapsed = today - startDay
  return Math.round((elapsed / total) * 100)
}

import { SHIPMENT_STATUS_OPTIONS } from 'src/shared/consts/quoteStatus'

const SHIPMENT_BADGE_STYLES: Record<string, string> = {
  '5_awaiting_shipment': 'bg-amber-50 text-amber-700 border-amber-200',
  '6_in_transit': 'bg-blue-50 text-blue-700 border-blue-200',
  '7_out_for_delivery': 'bg-indigo-50 text-indigo-700 border-indigo-200',
  '8_delivered': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  // Legacy values
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  shipped: 'bg-blue-50 text-blue-700 border-blue-200',
  out_for_delivery: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  delivered: 'bg-emerald-50 text-emerald-700 border-emerald-200',
}

/** Returns status badge color classes for shipment status. */
export const getStatusBadgeStyles = (status: string | null) => {
  if (!status) return 'bg-gray-50 text-gray-700 border-gray-200'
  return (
    SHIPMENT_BADGE_STYLES[status] ??
    (SHIPMENT_STATUS_OPTIONS.some((o) => o.value === status)
      ? 'bg-green-50 text-green-700 border-green-200'
      : 'bg-gray-50 text-gray-700 border-gray-200')
  )
}
